import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import {
  ShoppingCart,
  DoorOpen,
  Receipt,
  Banknote,
  Activity,
  SlidersHorizontal,
} from 'lucide-react';
import { cn } from '@/lib/utils';

import POS from '../POS';
import OpenClose from './OpenClose';
import Orders from '../Orders';
import CashManagement from './CashManagement';
import SellStatus from './Status';
import SellSettings from './SellSettings';

interface NavItem {
  id: string;
  label: string;
  icon: React.ElementType;
  path: string;
}

const navItems: NavItem[] = [
  { id: 'sell', label: 'Sell', icon: ShoppingCart, path: '/sell/register' },
  { id: 'open-close', label: 'Open / Close', icon: DoorOpen, path: '/sell/open-close' },
  { id: 'sales-history', label: 'Sales history', icon: Receipt, path: '/sell/sales-history' },
  { id: 'cash-management', label: 'Cash management', icon: Banknote, path: '/sell/cash-management' },
  { id: 'status', label: 'Status', icon: Activity, path: '/sell/status' },
  { id: 'settings', label: 'Settings', icon: SlidersHorizontal, path: '/sell/settings' },
];

export default function Sell() {
  return (
    <div className="flex h-full">
      <aside className="hidden lg:block w-56 shrink-0 border-r border-border/40 bg-background pt-[6.5rem]">
        <nav className="sticky top-[6.5rem] px-3 space-y-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.id}
                to={item.path}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                    'hover:bg-muted/70',
                    isActive
                      ? 'bg-primary/10 text-primary'
                      : 'text-muted-foreground hover:text-foreground'
                  )
                }
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </aside>

      <div className="flex-1 min-w-0 overflow-hidden">
        <Routes>
          <Route path="register" element={<POS />} />
          <Route path="open-close" element={<OpenClose />} />
          <Route path="sales-history" element={<Orders />} />
          <Route path="cash-management" element={<CashManagement />} />
          <Route path="status" element={<SellStatus />} />
          <Route path="settings" element={<SellSettings />} />
          <Route path="*" element={<Navigate to="/sell/register" replace />} />
        </Routes>
      </div>
    </div>
  );
}
